<!--
 * @Description: 异动反馈情况
 * @Author: cxh
 * @Date: 2023-05-16 18:23:48
 * @LastEditTime: 2023-06-21 16:41:58
 * @LastEditors: cxh
-->
<template>
  <div v-show="tableData && tableData.length">
    <div class="dc-card-header">
      <div class="dc-card-header-defaut">
        <div class="dc-card-header-defaut-line"></div>
        <p>{{ t('exception.exceptionDetails') }}</p>
      </div>
    </div>
    <a-form name="detailsForm" ref="baseFormRef" :model="tableData">
      <cos-table
        :columns="columns"
        :dataSource="tableData"
        :needPage="false"
        ref="tableRef"
        tableId="ofbuFollowBaseAlarm"
      >
        <template #bodyCell="{ column, index, record }">
          <template v-if="column.dataIndex === 'alarmDesc'">
            <a-form-item
              :name="[index, 'alarmDesc']"
              :rules="[
                {
                  required: record.alarmLevel === 1 || record.alarmLevel === 2 ? true : false,
                  message: t('common.pleaseSelect')
                },
                {
                  validator: (rule, value) => alarmLevelValidate(rule, value, record.arkCode, index)
                }
              ]"
            >
              <ParamCodesSelect
                :options="paramCodeData.ofbu_change_description"
                v-model:value="tableData[index].alarmDesc"
                v-model:label="tableData[index].alarmDescText"
                mode="multiple"
                :view="view"
              />
            </a-form-item>
          </template>
        </template>
      </cos-table>
    </a-form>
  </div>
</template>
<script lang="ts">
import { ref, watch, nextTick, onMounted } from 'vue'
import { followAlarmListGet } from '@/api/overseasSales/analysis'
import { FollowAlarmItem, FollowAlarmParams } from '@/typings/api/analysis'
import { alarmTypeEnum, alarmLevelEnum } from '@/views/overseasSales/commonEnum/dataConfig'
import { listByParamCodes } from '@/api/common'
import { useVModel } from '@vueuse/core'
import { paramCodesDataFilter } from '@/utils/index'
import type { Rule } from 'ant-design-vue/es/form'
import { cloneDeep } from 'lodash-es'
import { useI18n } from 'vue-i18n'
export default { name: 'DcCosFbuAccountCode' }
</script>
<script setup lang="ts">
const { t } = useI18n()
const tableRef = ref()
const baseFormRef = ref()
const tableData = ref<FollowAlarmItem[]>([])
const resetData = ref<FollowAlarmItem[]>([])
const paramCodeData = ref<any>({
  ofbu_change_description: [] // 异动说明
})
const props = defineProps({
  cosId: {
    type: String,
    require: true
  },
  followId: {
    // 跟进记录id
    type: String
  },
  pageType: {
    type: String,
    default: 'add'
  },
  view: {
    type: Boolean
  },
  value: {
    type: Object,
    default: () => {
      return {}
    }
  },
  alarmHasMain: {
    type: Boolean,
    default: false
  }
})
const emit = defineEmits(['update:value', 'update:alarmHasMain'])
const hasMain = useVModel(props, 'alarmHasMain', emit)

const alarmLevelValidate = async (rule: Rule, value: string[], arkCode: string, index: number) => {
  let valueText = ''
  if (value && value.length) {
    valueText = findLabel(value).join()
    if (valueText.includes('未流失') && valueText.includes('已流失')) {
      return Promise.reject(new Error(t('exception.alarm')))
    }
  }
  // 查找相同的客户代码
  let hasError = false
  const path = []
  let alarmDescTextValue = []
  for (let i = 0; i < tableData.value.length; i++) {
    const item = tableData.value[i]
    if (item.arkCode === arkCode && item.alarmDesc?.length) {
      alarmDescTextValue.push(...item.alarmDesc)
      path.push([i, 'alarmDesc'])
    }
  }
  alarmDescTextValue = findLabel(alarmDescTextValue).join()
  if (alarmDescTextValue.includes('未流失') && alarmDescTextValue.includes('已流失')) {
    hasError = true
  }
  if (hasError) {
    if (valueText.includes('未流失') || valueText.includes('已流失')) {
      return Promise.reject(new Error(t('exception.alarm')))
    } else {
      return Promise.resolve()
    }
  } else {
    // 是否清空error
    path.length && baseFormRef.value.clearValidate(path)
  }
  return Promise.resolve()
}
// 查找label
const findLabel = (arr: any) => {
  if (Array.isArray(arr)) {
    const labelAry: any = []
    const { ofbu_change_description } = paramCodeData.value
    arr.forEach((v) => {
      const find: any = ofbu_change_description.find((item: any) => item.id === v)
      labelAry.push(find?.name)
    })
    return labelAry
  }
}
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: ['ofbu_change_description']
  }).then((res) => {
    if (res.code === 200) {
      if (props.view) {
        paramCodeData.value = res.data
      } else {
        paramCodeData.value = paramCodesDataFilter(res.data, 0)
      }
    }
  })
}
onMounted(() => {
  getByParamCodes()
})
const columns = ref([
  {
    title: t('custom.arkCode'),
    dataIndex: 'arkCode'
  },
  {
    title: t('exception.exceptionTime'),
    dataIndex: 'alarmDate'
  },
  {
    title: t('exception.exceptionType'),
    dataIndex: 'alarmType',
    dicData: alarmTypeEnum
  },
  {
    title: t('exception.exceptionLevel'),
    dataIndex: 'alarmLevel',
    dicData: alarmLevelEnum
  },
  {
    title: t('exception.exceptionReason'),
    dataIndex: 'alarmInfo'
  },
  {
    title: t('exception.exceptionDes'),
    dataIndex: 'alarmDesc'
  }
])
const fetch = () => {
  if (!props.cosId) {
    tableData.value = []
    return
  }
  let p: FollowAlarmParams = {
    cosId: props.cosId
  }
  if (props.followId) {
    p = {
      followId: props.followId
    }
  }
  followAlarmListGet(p).then((res) => {
    tableData.value = res.data
    resetData.value = cloneDeep(tableData.value)
    // 是否有一二级异动情况
    if (tableData.value && !hasMain.value) {
      const mainIndex = tableData.value.findIndex((item) => item.alarmLevel === 1 || item.alarmLevel === 2)
      if (mainIndex !== -1) {
        hasMain.value = true
      }
    }
  })
}
watch(
  () => props.cosId,
  (v) => {
    hasMain.value = false
    fetch()
  }
)
// 处理
const validate = () => {
  return new Promise((resolve, reject) => {
    baseFormRef.value
      ?.validate()
      .then(async () => {
        const result: any[] = []
        tableData.value.forEach((item: FollowAlarmItem) => {
          result.push({
            alarmDesc: item.alarmDesc,
            alarmDescText: item.alarmDescText,
            alarmId: item.alarmId,
            arkCode: item.arkCode
          })
        })
        emit('update:value', {
          batch: result
        })
        resolve(result)
      })
      .catch((err: any) => {
        reject(err)
      })
  })
}
const reset = () => {
  tableData.value = cloneDeep(resetData.value)
  nextTick(() => {
    baseFormRef.value.clearValidate()
  })
}

defineExpose({ validate, reset })
</script>
